import * as React from "react"

export const TableOfContentsLink = ({ to, children }) => {
  return (
    <li key={to}>
      <a href={to}>{children}</a>
    </li>
  )
}

export const TableOfContents = ({ title, children }) => {
  return (
    <div>
      <p>{title}</p>

      <ol>{children}</ol>
    </div>
  )
}
